import React, { useState, useEffect } from "react";
import * as Helper from "../helpers.mjs";

// Only one of these can be ticked at a time
const MUTUALLY_EXCLUSIVE_SERVICES = ["86", "98"];

// The CT service carries a whole order label (the basket's bsLabel) chosen from its options (srOptions). Returns the whole
// order label that's actually in effect: the saved one if it's still an option, otherwise the first option. Null if there's no CT service.
const getWholeOrderLabel = (availableServices, wholeOrderLabel) => {
    for (const entry of availableServices || []) {
        for (const service of entry.services || []) {
            if (service.srCode == "CT" && service.srOptions) {
                const options = service.srOptions.split(",").filter(option => option !== "");
                return options.includes(wholeOrderLabel) ? wholeOrderLabel : (options[0] || null);
            }
        }
    }
    return null;
};

// The servicing options list, shared by the FS checkout's servicing step and the FS basket add/edit/copy modals.
// selectedServices is an array of service IDs. Ticks and the whole order label show straight away and are reported through
// onChange(ids, wholeOrderLabel) and onWholeOrderLabelChange(wholeOrderLabel); the props are followed whenever they change
// from outside (e.g. a servicing profile being applied).
const ServicingOptions = ({ availableServices, selectedServices, wholeOrderLabel, onChange, onWholeOrderLabelChange, idPrefix = "srId_", wholeOrderLabelSelectName }) => {
    const [selected, setSelected] = useState((selectedServices || []).map(String));
    const [currentWholeOrderLabel, setCurrentWholeOrderLabel] = useState(getWholeOrderLabel(availableServices, wholeOrderLabel));

    const selectedKey = (selectedServices || []).join(",");
    useEffect(() => {
        setSelected((selectedServices || []).map(String));
    }, [selectedKey]);

    useEffect(() => {
        setCurrentWholeOrderLabel(getWholeOrderLabel(availableServices, wholeOrderLabel));
    }, [wholeOrderLabel, availableServices]);

    const toggleService = (serviceId, checked) => {
        let newSelected = selected.filter(id => id !== serviceId);

        if (checked) {
            if (MUTUALLY_EXCLUSIVE_SERVICES.includes(serviceId)) {
                newSelected = newSelected.filter(id => !MUTUALLY_EXCLUSIVE_SERVICES.includes(id));
            }
            newSelected.push(serviceId);
        }

        setSelected(newSelected);
        onChange(newSelected, currentWholeOrderLabel);
    };

    const changeWholeOrderLabel = (newWholeOrderLabel) => {
        setCurrentWholeOrderLabel(newWholeOrderLabel);
        if (onWholeOrderLabelChange) {
            onWholeOrderLabelChange(newWholeOrderLabel);
        }
    };

    return (
        <div className="checkoutForm">
            <div className="servicingSections" style={{ borderTop: 0 }}>
                <p>To find out more about our wide selection of servicing options <a target="_blank" href="/book-servicing"><strong>click here</strong></a>.</p>
            </div>
            {(availableServices || []).map((entry, i) => (
                <div key={i} className="servicingSections servicingList">
                    <h3 className="servicingListTitle">{entry.title}</h3>
                    <table>
                        <tbody>
                            {(entry.services || []).map((service, k) => {
                                const serviceId = String(service.srId);
                                const idText = idPrefix + serviceId;
                                const isTicked = selected.includes(serviceId);

                                return (
                                    <tr key={k} className="servicingTable">
                                        <td className="servicingCheckbox">
                                            <label className="eventContainer" htmlFor={idText}>
                                                <input id={idText} type="checkbox" checked={isTicked} onChange={e => toggleService(serviceId, e.target.checked)} />
                                                <span className="eventCheckmark"></span>
                                            </label>
                                        </td>
                                        <td className="servicingTitle">
                                            {service.srCode == "CT" && service.srOptions
                                                ? <select name={wholeOrderLabelSelectName} value={currentWholeOrderLabel || ""} disabled={!isTicked} title="Whole order label" onChange={e => changeWholeOrderLabel(e.target.value)}>
                                                    {service.srOptions.split(",").filter(option => option !== "").map((option, j) => (
                                                        <option key={j} value={option}>{option}</option>
                                                    ))}
                                                </select>
                                                : <label htmlFor={idText}>{service.srTitle}</label>
                                            }
                                        </td>
                                        <td className="servicingPrice">
                                            {Helper.currency(service.srPrice)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
};

export { ServicingOptions, getWholeOrderLabel };
